'use strict';
import {module} from '../app';
import * as _ from 'lodash';
import * as riskPropertyConstants from '../constants/risk-property-constants';

module.filter('geneTestResultsFilterByResult', function(){
  let self = this;
  self.riskPropertyConstants = riskPropertyConstants;
  return function(geneOptions, answerIndex){
    const filteredOptions = geneOptions.filter(option => {
      const sortedOptionsArray = _.sortBy(option.Options, self.riskPropertyConstants.defaultSortingColumn);
      const currentOption = sortedOptionsArray[answerIndex];
      return currentOption.Value === option.Response;
    });
    return filteredOptions;
  };


});


// WEBPACK FOOTER //
// ./src/scripts/filters/geneTestResultsFilterByResult.js